import { warningIcon } from '@/uiIcons/warningIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { textBlock } from '@/uiPrimitives/typography/text';
import { PropsWithChildren } from 'react';

/* Generic error-message */
export const ErrorMessage = ({ children }: PropsWithChildren) => {
	return (
		<div
			className={classes(
				box({ backgroundColor: 'negativeRed', padding: '1 | h3' }),
			)}
		>
			<div
				className={classes(
					shelf({
						gridTemplateColumns: 'auto minmax(0, 1fr)',
						columnGap: '0 | p',
					}),
				)}
			>
				<i
					className={classes(
						icon({ icon: warningIcon, size: '1 | h3', fill: 'positiveRed' }),
					)}
				/>
				<p className={classes(textBlock({}))}>{children}</p>
			</div>
		</div>
	);
};
